import {
  buildApplyStageRoutePath,
  useDefineProviderRoute,
} from "@versatile-credit-apply/composition"
import { type RouteRecordRaw } from "vue-router"
import { StepperId } from "@/models/stepper/stepper-id"
import {
  ScreenId,
  type StaticProviderKey,
} from "@versatile-credit-apply/omni-apply-client"

const providerKey: StaticProviderKey = "aff_standard"
const { defineRoute } = useDefineProviderRoute(providerKey)

export const routes: RouteRecordRaw[] = [
  defineRoute({
    path: "/apply/:applyStage/responses/prequalified",
    inherit: true,
    component: () =>
      import("@/providers/aff_standard/views/AffPrequalifiedView.vue"),
    meta: {
      preventBack: true,
      screenId: ScreenId.OFFER_PRESENTATION_PREQUAL,
    },
  }),

  defineRoute({
    path: "/apply/:applyStage/offer-continue/:applicantType/:id",
    inherit: true,
    component: () => import("@/providers/aff_standard/views/AffTermsView.vue"),
    props: true,
    meta: {
      step: "applicant",
      stepper: StepperId.APPLY,
    },
  }),

  defineRoute({
    path: "/apply/:applyStage/responses/approved",
    inherit: true,
    component: () =>
      import("@/providers/aff_standard/views/AffApprovedView.vue"),
    meta: {
      preventBack: true,
      screenId: ScreenId.OFFER_PRESENTATION_FULL,
    },
  }),

  defineRoute({
    path: "/apply/:applyStage/patchSuccess",
    inherit: true,
    redirect: (to) =>
      buildApplyStageRoutePath(
        to.params.providerKey as string,
        "/down-payment",
        { params: to.params }
      ),
  }),

  defineRoute({
    name: "apply.esign",
    path: "/apply/:applyStage/esign",
    meta: {
      step: "terms",
      stepper: StepperId.APPLY,
    },
    component: () =>
      import("@/providers/aff_standard/views/AffApplyEsignView.vue"),
  }),

  defineRoute({
    name: "apply.complete",
    path: "/apply/:applyStage/completed",
    meta: {
      step: "decision",
      stepper: StepperId.APPLY,
    },
    component: () =>
      import("@/providers/aff_standard/views/AffCompletedView.vue"),
  }),
]
